const init =  (component: HTMLElement) => {
  const buttonWorkshop = component.querySelector('.garage-calendar__button--workshop');
  const timetableWorkshop = component.querySelector('.garage-calendar__timetable--workshop');

  const buttonShowroom = component.querySelector('.garage-calendar__button--showroom');
  const timetableShowroom = component.querySelector('.garage-calendar__timetable--showroom');

  buttonShowroom?.addEventListener('click', () => {
    timetableShowroom?.classList.add('active');
    buttonShowroom.classList.add('active');
    buttonWorkshop?.classList.remove('active');
    timetableWorkshop?.classList.remove('active');
  });

  buttonWorkshop?.addEventListener('click', () => {
    buttonWorkshop.classList.add('active');
    timetableWorkshop?.classList.add('active');
    timetableShowroom?.classList.remove('active');
    buttonShowroom?.classList.remove('active');
  });

};

export default init;